import { useState } from 'react';
import Message from './Message.jsx';
import MessageInput from './MessageInput.jsx';
import { useModalStore } from '../../stores/modalStore.js';
import { useMemberStore } from '../../stores/memberStore.js';

export default function AnnouncementView({ channel, messages, replyTo, onReply, onThread, serverId }) {
  const [followed, setFollowed] = useState(() => {
    try { return JSON.parse(localStorage.getItem('followed-channels') || '[]').includes(channel?.id); } catch { return false; }
  });
  const { onOpen } = useModalStore();

  let currentUser = null;
  try { currentUser = useMemberStore.getState().getCurrentUser(); } catch (_) {}
  const isAdmin = currentUser?.role?.toUpperCase() === 'ADMIN' || currentUser?.role?.toUpperCase() === 'OWNER';

  const toggleFollow = () => {
    setFollowed(v => {
      const next = !v;
      try {
        const list = JSON.parse(localStorage.getItem('followed-channels') || '[]');
        const updated = next ? [...list, channel?.id] : list.filter(id => id !== channel?.id);
        localStorage.setItem('followed-channels', JSON.stringify(updated));
      } catch (_) {}
      return next;
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      {/* Announcement banner */}
      <div style={{ padding: '10px 16px', background: 'rgba(245,158,11,0.08)', borderBottom: '1px solid rgba(245,158,11,0.2)', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
        <span style={{ fontSize: 18 }}>📢</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: '#f59e0b' }}>Announcement Channel</span>
          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginLeft: 8 }}>Only admins & mods can post · Follow to get updates in your server</span>
        </div>
        <button
          onClick={toggleFollow}
          style={{ padding: '5px 14px', borderRadius: 6, border: `1px solid ${followed ? 'rgba(245,158,11,0.5)' : 'rgba(255,255,255,0.15)'}`, background: followed ? 'rgba(245,158,11,0.15)' : 'rgba(255,255,255,0.06)', color: followed ? '#f59e0b' : 'rgba(255,255,255,0.6)', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.15s', flexShrink: 0 }}
        >
          {followed ? '✓ Following' : '＋ Follow'}
        </button>
      </div>

      {/* Messages — read-only for non-admins */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0' }}>
        {messages.length === 0 ? (
          <div style={{ padding: '60px 24px', textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 10 }}>📢</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#fff', marginBottom: 6 }}>No announcements yet</div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)' }}>Admins can post announcements here. Follow to receive updates.</div>
          </div>
        ) : messages.map(msg => (
          <Message
            key={msg.id}
            {...msg}
            author={msg.senderName || msg.author}
            text={msg.text || msg.content}
            onReply={onReply}
            onThread={(m) => onOpen('thread', { message: m, serverId, channelId: channel?.id })}
          />
        ))}
      </div>

      {/* Input — locked for non-admins */}
      {isAdmin ? (
        <MessageInput replyTo={replyTo} onCancelReply={() => onReply(null)} />
      ) : (
        <div style={{ padding: '12px 16px', borderTop: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ flex: 1, padding: '10px 14px', borderRadius: 8, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', fontSize: 13, color: 'rgba(255,255,255,0.25)', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>🔒</span>
            <span>Only admins and moderators can post in announcement channels</span>
          </div>
        </div>
      )}
    </div>
  );
}
